/**
 * Workflow Service `FileStorageType` enum + `GET .../reference/workflow/filestorage` (ACME-1998 / ACME-2134).
 * Must stay lowercase and match api-workflow-service `FileStorageType.cs`.
 */
export const JHA_NETWORK_SFTP_STORAGE = "jhanetworksftp";
export const JHA_NETWORK_FILESHARE_STORAGE = "jhanetworkfileshare";

export function normalizeStorageTypeKey(key: string | undefined | null): string {
	return String(key ?? "").trim().toLowerCase();
}

export function isJhaNetworkSftpStorageType(key: string | undefined | null): boolean {
	return normalizeStorageTypeKey(key) === JHA_NETWORK_SFTP_STORAGE;
}

export function isJhaNetworkFileShareStorageType(key: string | undefined | null): boolean {
	return normalizeStorageTypeKey(key) === JHA_NETWORK_FILESHARE_STORAGE;
}

export function isJhaNetworkStorageType(key: string | undefined | null): boolean {
	const k = normalizeStorageTypeKey(key);
	return k === JHA_NETWORK_SFTP_STORAGE || k === JHA_NETWORK_FILESHARE_STORAGE;
}
